import React from 'react';
import styled from 'styled-components';

import { NotificationProps } from 'src/firebase/db/Notifications';

import StyleConfig from 'src/constants/StyleConfig';
import OrderBreadListItem from 'src/components/molecules/list/OrderBreadListItem';
import NotificationTimeStampHeader from 'src/components/organisms/header/NotificationTimeStampHeader';

type Props = {
  notifications: NotificationProps[];
  onDelete: (id: string) => void;
};

const OrderBreadList = (props: Props) => {
  const { notifications, onDelete } = props;

  return (
    <OrderBreadListContainer>
      {notifications.map((notification, i) => (
        <div key={notification.id}>
          <NotificationTimeStampHeader notification={notification} />
          <OrderBreadListItem notification={notification} onDelete={onDelete} />
        </div>
      ))}
    </OrderBreadListContainer>
  );
};

const OrderBreadListContainer = styled.div`
  margin-bottom: ${StyleConfig.HELPER.M16};

  > * {
    margin-bottom: 40px;
  }
`;

export default OrderBreadList;
